import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

export default function Error403() {
    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-900 via-red-900 to-slate-800 flex items-center justify-center relative overflow-hidden">
            {/* Background decorative elements */}
            <div className="absolute top-20 right-20 w-64 h-64 bg-red-500/10 rounded-full blur-3xl"></div>
            <div className="absolute bottom-20 left-20 w-48 h-48 bg-orange-500/10 rounded-full blur-3xl"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-red-600/5 rounded-full blur-3xl"></div>

            <div className="text-center z-10 px-4">
                {/* Logo Section */}
                <div className="mb-16">
                    <div className="flex items-center justify-center mb-2">
                        <div className="text-left">
                            <img width={300} src="/logos/with-text-white.png" alt="Logo" />
                        </div>
                    </div>
                </div>

                {/* Main Content */}
                <div className="bg-slate-800/30 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-12 max-w-md mx-auto">
                    {/* Shield Icon */}
                    <div className="flex justify-center mb-6">
                        <div className="bg-red-500/10 p-6 rounded-full border border-red-500/20">
                            <ShieldAlert className="w-16 h-16 text-red-500" />
                        </div>
                    </div>

                    {/* 403 Number */}
                    <h2 className="text-8xl font-bold text-white mb-6 tracking-tight">403</h2>

                    {/* Error Message */}
                    <h3 className="text-lg sm:text-xl font-semibold text-white mb-4">Access Denied</h3>
                    <p className="text-gray-400 mb-8 text-sm leading-relaxed">
                        You don't have permission to access this page. Please contact your administrator if you believe this is an error.
                    </p>

                    {/* Go Home Button */}
                    <Link
                        to="/"
                        className="inline-block bg-red-500 hover:bg-red-600 text-white font-medium px-8 py-3 rounded-lg transition-colors duration-200 text-sm"
                    >
                        Go To Home
                    </Link>
                </div>
            </div>
        </div>
    );
}